<template>
    <div class="checkout-page">
      <h1>Баталгаажуулах</h1>
      <div class="section">
        <h2>Сагсанд байгаа бүтээгдэхүүн</h2>
        <el-table :data="basketItemsGetter" border>
          <el-table-column prop="product_name" label="Бүтээгдэхүүний нэр" width="150"></el-table-column>
          <el-table-column prop="item_count" label="Тоо" width="50"></el-table-column>
          <el-table-column label="Үнэ" width="90">
            <template slot-scope="scope"> {{ scope.row.item_price | formatCurrency }} </template>
          </el-table-column>
          <el-table-column label="Нийт үнэ" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.item_count * scope.row.item_price | formatCurrency}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="section">
        <h2>Захиалгийн дэлгэрэнгүй</h2>
        <el-form :model="order" :rules="rules" label-width="120px" :span="24" ref="orderForm">

          <el-form-item label="Хот, аймаг" prop="address_city">
            <el-col :xs="20" :sm="20" :md="24" :lg="24" :xl="24">
                <el-select  name="countries" v-model="order.address_city" placeholder="Хот аймаг сонгох">
                  <el-option
                      v-for="item in cities"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="Дүүрэг" prop="address_district">
            <el-col :xs="20" :sm="20" :md="24" :lg="24" :xl="24">
              <el-select id="country" name="address_district" v-model="order.address_district">
                <el-option
                    v-for="item in districts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="Хороо" prop="address_khoroo">
            <el-col :xs="20" :sm="20" :md="24" :lg="24" :xl="24">
              <el-select id="country" name="countries" v-model="order.address_khoroo">
                <el-option
                    v-for="item in khoroos"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="Тоот" prop="address_bair">
            <el-col :xs="20" :sm="20" :md="24" :lg="24" :xl="24">
                <div>
                    <el-input id="addres" type="text" placeholder="1 байр /123 тоот" v-model="order.address_bair"></el-input>
                </div>
            </el-col>
          </el-form-item>

          <el-form-item label="Хаягийн дэлгэрэнгүй" prop="address_description">
              <el-col :xs="20" :sm="20" :md="24" :lg="24" :xl="24">
                  <el-input type="textarea" id="addres" placeholder="Бид таныг олоход туслаарай. /Мухар гудамж, Ганцхан байр, Хаалттай шүү гэх мэт/" v-model="order.address_description"></el-input>
              </el-col>
          </el-form-item>

          <el-form-item label="Утас" prop="customer_phone">
              <el-col :xs="20" :sm="20" :md="24" :lg="24" :xl="24">
                  <el-input id="pho" v-model="order.customer_phone" type="number" placeholder="Үндсэн утас"></el-input>
              </el-col>
          </el-form-item>

          <el-form-item label="Захиалгын тэмдэглэл">
              <el-col :xs="20" :sm="20" :md="24" :lg="24" :xl="24">
                  <el-input type="textarea" id="note" v-model="order.order_description" cols="30" rows="5" placeholder="Ирээд залгаарай, ирхээсээ өмнө залгаарай гэх мэт :), дөхөөд хэлээрэй гараад авна." />
              </el-col>
          </el-form-item>
        </el-form>
      </div>

      <!-- Actions -->
      <div class="actions">
        <el-button class="text_item_color" :style="'background-color:' + bgColor()" @click="saveOrder('orderForm')">Захиалах</el-button>
      </div>

      <!-- Order Success Dialog -->
      <el-dialog title="Order Success">
        <p>Your order has been placed successfully!</p>
        <el-button type="primary">OK</el-button>
      </el-dialog>
    </div>
  </template>

<script>
import services from '@/helpers/services.js'
import {
  mapGetters
} from 'vuex'
export default {
  data () {
    return {
      deliveryPrice: 0,
      valueNumber: 1,
      checked: false,
      cities: [{
        value: 'Ulaanbaatar',
        label: 'Улаанбаатар'
      }, {
        value: 'Erdenet',
        label: 'Эрдэнэт'
      }, {
        value: 'Dornod',
        label: 'Дорнод'
      }],
      districts: [
        {
          value: 'БЗД',
          label: 'БЗД'
        },
        {
          value: 'ХУД',
          label: 'ХУД'
        },
        {
          value: 'БГД',
          label: 'БГД'
        },
        {
          value: 'СБД',
          label: 'СБД'
        },
        {
          value: 'СХД',
          label: 'СХД'
        },
        {
          value: 'ЧД',
          label: 'ЧД'
        },
        {
          value: 'НАЛАЙХ',
          label: 'НАЛАЙХ'
        },
        {
          value: 'НД',
          label: 'НД'
        }
      ],
      khoroos: [{
        value: '1 хороо',
        label: '1 хороо'
      },
      {
        value: '2 хороо',
        label: '2 хороо'
      },
      {
        value: '3 хороо',
        label: '3 хороо'
      }, {
        value: '4 хороо',
        label: '4 хороо'
      }, {
        value: '5 хороо',
        label: '5 хороо'
      }, {
        value: '6 хороо',
        label: '6 хороо'
      }, {
        value: '7 хороо',
        label: '7 хороо'
      }, {
        value: '8 хороо',
        label: '8 хороо'
      }, {
        value: '9 хороо',
        label: '9 хороо'
      }, {
        value: '10 хороо',
        label: '10 хороо'
      }, {
        value: '11 хороо',
        label: '11 хороо'
      }, {
        value: '12 хороо',
        label: '12 хороо'
      }, {
        value: '13 хороо',
        label: '13 хороо'
      }, {
        value: '14 хороо',
        label: '14 хороо'
      }, {
        value: '15 хороо',
        label: '15 хороо'
      }, {
        value: '16 хороо',
        label: '16 хороо'
      }, {
        value: '17 хороо',
        label: '17 хороо'
      }, {
        value: '18 хороо',
        label: '18 хороо'
      }, {
        value: '19 хороо',
        label: '19 хороо'
      }, {
        value: '20 хороо',
        label: '20 хороо'
      }, {
        value: '21 хороо',
        label: '21 хороо'
      }, {
        value: '22 хороо',
        label: '22 хороо'
      }, {
        value: '23 хороо',
        label: '23 хороо'
      }, {
        value: '24 хороо',
        label: '24 хороо'
      }, {
        value: '25 хороо',
        label: '25 хороо'
      }, {
        value: '26 хороо',
        label: '26 хороо'
      }, {
        value: '27 хороо',
        label: '27 хороо'
      }, {
        value: '28 хороо',
        label: '28 хороо'
      }, {
        value: '29 хороо',
        label: '29 хороо'
      }, {
        value: '30 хороо',
        label: '30 хороо'
      }, {
        value: '31 хороо',
        label: '31 хороо'
      }, {
        value: '32 хороо',
        label: '32 хороо'
      }, {
        value: '33 хороо',
        label: '33 хороо'
      }, {
        value: '34 хороо',
        label: '34 хороо'
      }, {
        value: '35 хороо',
        label: '35 хороо'
      }, {
        value: '36 хороо',
        label: '36 хороо'
      }, {
        value: '37 хороо',
        label: '37 хороо'
      }, {
        value: '38 хороо',
        label: '38 хороо'
      }, {
        value: '39 хороо',
        label: '39 хороо'
      }, {
        value: '40 хороо',
        label: '40 хороо'
      }, {
        value: '41 хороо',
        label: '41 хороо'
      }, {
        value: '42 хороо',
        label: '42 хороо'
      }, {
        value: '43 хороо',
        label: '43 хороо'
      }, {
        value: '44 хороо',
        label: '44 хороо'
      }, {
        value: '45 хороо',
        label: '45 хороо'
      }, {
        value: '46 хороо',
        label: '46 хороо'
      }, {
        value: '47 хороо',
        label: '47 хороо'
      }],
      order: {
        branch_name: 'Eruulhun.mn',
        company_name: 'Eruulhun.mn',
        address_city: 'Улаанбаатар',
        address_district: null,
        address_id: null,
        address_khoroo: null,
        address_bair: null,
        address_description: '',
        order_type: '1',
        customer_phone: null,
        order_channel: 'web',
        pay_type: '1',
        vat_type: 1,
        vat_regno: null,
        vat_cust_name: '',
        order_description: '',
        order_status: 40,
        worker_key: null,
        pos_number: '',
        total_amount: 0,
        item_count: 1,
        promo_code: '',
        products: [],
        total_count: 0
      },
      rules: {
        address_city: [
          { required: true, message: 'Аймаг хот сонгоогүй байна', trigger: 'blur' }
        ],
        address_district: [
          { required: true, message: 'Дүүрэг сонгоогүй байна', trigger: 'blur' }
        ],
        address_khoroo: [
          { required: true, message: 'Хороо сонгоогүй байна', trigger: 'blur' }
        ],
        address_description: [
          { required: true, message: 'Хаягийн дэлгэрэнгүй', trigger: 'blur' }
        ],
        customer_phone: [
          { required: true, message: 'Үйлчлүүлэгчийн утасны дугаар', trigger: 'blur' }
        ]
      },
      payment: {
        cash: 0,
        credit_card: 0,
        coupon: 0,
        loyalty_point: 0,
        account: 0
      }
    }
  },
  computed: {
    // totalPrice () {
    //   return this.basketItems.reduce((sum, item) => sum + item.price * item.quantity, 0)
    // },
    ...mapGetters([
      'basketItemsGetter',
      'lastOrderGetter'
    ])
  },
  methods: {
    saveOrder (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.order.total_amount = this.totalAmountCalc()
          this.order.total_count = this.totalCountCalc()
          const payload = {
            order: this.order,
            products: this.basketItemsGetter,
            payment: this.payment
          }
          this.$root.fullscreenLoading = true
          services.orderSave(payload)
            .then((response) => {
              this.$store.dispatch('addLastOrder', response)
              this.$store.dispatch('clearBasket')
              if (response) {
                this.$root.fullscreenLoading = false
                this.$alert('Таны захиалга амжилттай бүртгэгдлээ', 'Амжилттай', {
                  confirmButtonText: 'Ойлголоо',
                  callback: action => {
                    const payload = {
                      to: this.lastOrderGetter.customer_phone,
                      text: 'Таны ' + this.lastOrderGetter.id + ' дугаартай захиалга амжилттай баталгаажлаа. ХХБ банкны 404320221 / Саруулбат / тоот дансанд ' + this.lastOrderGetter.total_amount + ' төгрөгийг ' + this.lastOrderGetter.id + ' гүйлгээний утгатай гүйлгээ хийгдсэний дараа захиалга баталгаажна. '
                    }
                    services.successOrderSendInfo(payload)
                      .then((response) => {
                        console.log(response, action)
                      })
                      .catch((err) => {
                        console.log(err)
                      })
                    this.$router.push({
                      path: '/payment_auth'
                    })
                  }
                })
              }
              console.log(response)
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    totalAmountCalc () {
      let sum = 0
      let total = 0
      this.basketItemsGetter.forEach(element => {
        sum = element.item_price * element.item_count
        total = sum + total
      })
      return total
    },
    totalCountCalc () {
      let sum = 0
      this.basketItemsGetter.forEach(element => {
        sum = sum + element.item_count
      })
      return sum
    },
    bgColor () {
      if (window.location.hostname === 'www.iteever.mn') {
        return '#5E1EE5'
      } else if (window.location.hostname === 'www.eruulhun.com') {
        return '#64a29f'
      } else if (window.location.hostname === 'localhost') {
        return '#64a29f'
      }
    }
  }
}
</script>

<style lang="scss">
  .checkout-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 30px;

    h1 {
      text-align: center;
      margin-bottom: 30px;
    }

    .section {
      margin-bottom: 40px;

      h2 {
        margin-bottom: 15px;
      }

      p {
        margin: 5px 0;
      }

      .total-summary {
        margin-top: 10px;
        font-size: 18px;
        font-weight: bold;
        text-align: right;
      }
    }

    .actions {
      text-align: center;
      margin-top: 20px;
    }

    .text_item_color{
      color: white;
    }
  }
</style>
